let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fERvE")).then(() => parcelRequire('43bOU'));